import React, { useContext } from "react";
import { FilterArea, MicroBar } from "@sia/style-guide";
import { usePageRefresh } from "../tools";
import { MasterKeyContext } from "contexts/MasterKeyContext";
import { updateOverheadPageFilters } from "./stateUpdaters";
import "./OverheadsPage.scss";
import OperatingCostsChart from "./charts/OperatingCostsChart";
import PersonalCostsChart from "./charts/PersonalConstsChart";
import Legend from "../Shared/Legend/Legend";
export default function OverheadsPage({ translate, filters, setFilters, data, selectedTab, setSelectedTab, showCustomerData, setShowCustomerData }) {
  if (Array.isArray(data) && data.length === 0) {
    return null;
  }
  const OVERHEADS_PAGE_TAB_INDEX = 1;
  usePageRefresh(selectedTab, OVERHEADS_PAGE_TAB_INDEX, setSelectedTab);

  const { isMasterKeyValid } = useContext(MasterKeyContext);

  const { expensesPerPeriod } = data;
  const { costCategories } = expensesPerPeriod[0];
  const personnelCosts = costCategories.find((cat) => cat.costCategory === "personnel_costs");
  const operatingCosts = costCategories.find((cat) => cat.costCategory === "operating_costs");
  const canDisplayOwnData = isMasterKeyValid && personnelCosts.metrics[0].accounts.every((account) => account.companyValue !== null);
  return (
    <div className="benchmarking-overheads-container sia-padding-02-left sia-padding-02-right sia-padding-04-top" id="sia-overheads-page">
      {filters && (
        <FilterArea
          translate={translate}
          initialFilters={filters}
          onFiltersUpdate={(filterAreaState) => {
            updateOverheadPageFilters(setFilters, filterAreaState);
          }}
          widthFormula={"calc(100%)"}
        />
      )}

      <div className="sia-padding-02-bottom benchmarking-overheads-bar-container">
        {personnelCosts && (
          <MicroBar
            translate={translate}
            realData={personnelCosts.metrics[0].accounts[0].benchmark.coverage.organicCategories}
            availableData={personnelCosts.metrics[0].accounts[0].benchmark.coverage.totalCategories}
            weight={personnelCosts.metrics[0].accounts[0].benchmark.coverage.organicWeightPercent}
            isSyntheticDataIncluded={data.syntheticDataIncluded}
          />
        )}
        <Legend
          canDisplayOwnData={canDisplayOwnData}
          showCustomerData={canDisplayOwnData && showCustomerData}
          setShowCustomerData={setShowCustomerData}
          translate={translate}
        />
      </div>
      {operatingCosts ? <OperatingCostsChart translate={translate} metrics={operatingCosts} showCustomerData={showCustomerData} /> : null}
      <div className="sia-padding-05-top">
        {personnelCosts ? <PersonalCostsChart translate={translate} metrics={personnelCosts} showCustomerData={showCustomerData} /> : null}
      </div>
    </div>
  );
}
